import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { StickyMarketButton, FloatingProductPreview, AnnouncementBanner } from './components/MarketFeatures';

// Pages
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { EducationPage } from './pages/EducationPage';
import { NewsPage } from './pages/NewsPage';
import { JoinPage } from './pages/JoinPage';
import { MarketPage } from './pages/MarketPage';
import { ProductPage } from './pages/ProductPage';
import { ProducerPage } from './pages/ProducerPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { ContactPage } from './pages/ContactPage';
import { LegalPage } from './pages/LegalPage';
import NotFoundPage from './pages/NotFoundPage';

import './index.css';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen flex flex-col bg-[#F9F8F6]">
            <AnnouncementBanner />
            <Header />
            <main className="flex-1 pt-24">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/hakkimizda" element={<AboutPage />} />
                <Route path="/calismalarimiz" element={<ProjectsPage />} />
                <Route path="/egitim" element={<EducationPage />} />
                <Route path="/haberler" element={<NewsPage />} />
                <Route path="/katil" element={<JoinPage />} />
                <Route path="/market" element={<MarketPage />} />
                <Route path="/market/urun/:productId" element={<ProductPage />} />
                <Route path="/market/uretici/:producerId" element={<ProducerPage />} />
                <Route path="/market/sepet" element={<CartPage />} />
                <Route path="/market/siparis" element={<CheckoutPage />} />
                <Route path="/iletisim" element={<ContactPage />} />
                <Route path="/yasal/:page" element={<LegalPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <Footer />
            
            {/* Global UI Components */}
            <StickyMarketButton />
            <FloatingProductPreview />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
